
import { Component, ElementRef, ViewChild } from '@angular/core';
import { debounceTime } from 'rxjs/operators';
import { PageBase, RentalOrderSummary, TurboHubEventType } from 't4core';
import { NewCustomerDialog } from '../../dialogs/NewCustomerDialog/NewCustomerDialog';
import { T4DatatableWidget } from '../../../../t4common/components/datatable/datatable';


@Component({
    selector: 'home',
    templateUrl: './home.component.html',
})
export class HomeComponent extends PageBase {

    constructor(el: ElementRef) {
        super(el, "Order");

        // TODO Implement signal R
        //this.SignalR.sub(TurboHubEventType.Order).pipe(debounceTime(1000)).subscribe(x => {
        //    this.loadMyOrders();
        //});
    }

    @ViewChild("tblOrders", { static: false }) public tblOrders: T4DatatableWidget;
    public isLoading: boolean = false;

    public checkPendingOrders(): boolean {
      if (this.tblOrders)
        return this.tblOrders?.data.filteredData.some(x => x.Status == 50);
      return false;
    }

    public newCustomer() {
      this.Dialog.open(NewCustomerDialog, {
        data: { }
      });
    }
    public async resendPendingOrders() {
      var x = await this.UI.confirm('TO.ResendPendingOrdersDialog.ResendPendingOrdersHeadline1', 'Resend pending orders?', 'TO.ResendPendingOrdersDialog.confirmResendPendingOrdersMessage1', 'Are you sure that the pending failed orders are deleted in annata to process it again ?')
      if (x) {
        try {

          var ret = this.Api.put<any[]>("/TurboOrder/resendPendingOrders");
          if (ret) {
            this.tblOrders.update();
            this.UI.alert("TO.ResendPendingOrders.titleSuccess", "Update Success!", "TO.ResendPendingOrders.msgSuccess1", "Resend pending orders completed.");
          }
        } catch (ex) {
          this.UI.alert("TO.ResendPendingOrders.headResendPendingOrdersError", "Update failed!", "TO.ResendPendingOrders.msgResendPendingOrdersError", 'Orders have not been updated');
        }
      }
    }
}
